import store from '@/store/index.js'
import { makeRequest } from '@/libs/RequestModule'

const getMenuRestaurants = async function () {
    const restaurants = (await makeRequest('getMenuRestaurants'))?.data
    store.dispatch('setMenuRestaurants', restaurants)
}

const getRestaurantGroups = async function (CDFILIAL, CDLOJA, NRCONFTELA) {
    const groups = (await makeRequest('getRestaurantGroups', { CDFILIAL, CDLOJA, NRCONFTELA }))?.data
    store.dispatch('setMenuGroups', groups)
}

const buildMenu = async function (CDCLIENTE, CDFILIAL, CDCAIXA, CDLOJA, NRCONFTELA, groups) {
    const menu = (await makeRequest('buildMenu', { CDCLIENTE, CDFILIAL, CDCAIXA, CDLOJA, NRCONFTELA, groups }))?.data
    return menu ? menu.cardapio : []
}

export { getMenuRestaurants, buildMenu, getRestaurantGroups }
